import actionTypes from 'constants/modals-action-types';
import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type ExamModalsStore = {
    modals: Map<unknown, unknown>;
};

const initialState = (): ExamModalsStore => {
    return {
        modals: Immutable.OrderedMap(),
    };
};

const actionsMap: ActionsMap<ExamModalsStore> = {
    [actionTypes.REGISTER_MODAL]: (state, action) => {
        return {
            modals: state.modals.set(action.modalId, action.modal),
        };
    },
    [actionTypes.RETIRE_MODAL]: (state, action) => {
        return {
            modals: state.modals.delete(action.modalId),
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ExamModalsStore>(initialState(), actionsMap);
